import {
  AppName,
  currentAppEnvironment,
} from '@savgroup-front-common/constants';

import { DEFAULT_TERM_SUGGESTION_APP_NAME } from './dynamicTermSuggestion.configuration';

export const buildTermSuggestionOrigin = ({
  appName,
}: {
  appName?: AppName;
}): string =>
  `${appName ?? DEFAULT_TERM_SUGGESTION_APP_NAME}@${currentAppEnvironment.toLowerCase()}`;
